// extracted by mini-css-extract-plugin
export default {"wrap":"price_wrap__m7lpP","symbol":"price_symbol__99EU2"};